const app = {
	userActions: {
		submit: 'Absenden',
		next: 'Weiter',
		back: 'Zurück',
		start: 'Starten',
		choose: 'Wählen',
		delete: 'Entfernen',
		toLastStep: 'Zum letzten Schritt',
		backToStart: 'Zurück zum Start',
		change: 'Ändern'
	},
	userFeedback: {
		step: 'Schritt',
		loadDataErrorMessage: 'Beim bereitstellen der Daten ist ein Fehler aufgereten',
		checkData: 'Daten prüfen',
		error: 'Fehler',
		forms: {
			errors: {
				cannotBeEmpty: 'Das Eingabefeld darf nicht leer sein.',
				mustBeNumber: 'Die Eingabe muss eine Zahl sein.',
				decimalsNotAllowed: 'Die Eingabe darf kein Komma enthalten.',
				cantStartWithZero: 'Die Eingabe darf nicht mit einer Null beginnen.',
				numbersNotAllowed: 'Die Eingabe darf keine Zahlen enthalten.',
				mustBeEmail: 'Der eingegebene Wert ist keine valide Email',
				mustBeUrl: 'Der eingegebene Wert ist keine valide URL',
				smallerOneNotAllowed: 'Der eingegebene Wert darf nicht kleiner als 1 sein'
			}
		},
		errors: {
			noConnection: 'Fehler beim Verbindungsaufbau. Email konnte nicht versendet werden',
			unknown: 'Ein unbekannter Fehler ist aufgetreten'
		}
	}
};

const en = {
	...app
};

export default en;
